/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useMemo, useLayoutEffect, useEffect, useState} from "react";
import objectPath from "object-path";
import {Link, useHistory, useLocation} from "react-router-dom";
import {
  useSubheader,
} from "../../_core/MetronicSubheader";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {useIntl} from "react-intl";
import {getMenu} from "../../../../_emywork/UIMenu";
import {LanguageSelectorDropdown} from "../extras/dropdowns/LanguageSelectorDropdown";
import {AERole} from "../../../../_emywork/components/AERole";
import {getConfig, setEmyRole} from "../../../i18n";
import {Tooltip} from "react-bootstrap";
import {AESVG} from "../../../../_emywork/components/svg";
import {AEOverlayTrigger} from "../../../../_emywork/AEOverlayTrigger";
import {QuickUserToggler} from "../extras/QuickUserToggler";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {AEButton} from "../../../../_emywork/components/buttons";
import {requestEmailVerificationLink} from "../../../../app/modules/Auth/_redux/authCrud";
import {toast} from "react-toastify";
import {roles} from "../../../../index";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_helpers";
import * as actions from "../../../../app/pages/Dashboard/_redux/actions";

export function SubHeader() {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const history = useHistory();
  const {formatMessage, formatHTMLMessage} = useIntl()
  const subheader = useSubheader();
  const {role} = getConfig();
  const [MENU, setMenu] = useState([]);
  const {isEmailVerified = false, authUser} = useSelector( ({auth}) => ({
    isEmailVerified: auth.user &&!!auth.user.email_verified_at,
    authUser:auth.user
  }), shallowEqual );

  const notificationsStatistics = useSelector(({statistics})=>statistics.notifications)
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(actions.fetchNotificationsStatistics())
    dispatch(actions.fetchWalletStatistics())
  }, [])

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderFixed: objectPath.get(uiService.config, "subheader.fixed"),
      subheaderMobileToggle: objectPath.get(  uiService.config, "subheader.mobile-toggle" ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses( "subheader_container", true ),
    };
  }, [uiService]);

  useLayoutEffect(() => {
    // const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    // const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    // const currentRoute = getMenuItemByPathname(location.pathname);
    // console.log(currentRoute)
    // let breadcrumbs = [currentRoute];
    // const getParent = (menuItem)=>{
    //   // console.log(menuItem)
    //   if(menuItem.parent) {
    //     breadcrumbs.push(menuItem.parent);
    //     getParent(menuItem.parent)
    //   }
    // }
    // getParent(currentRoute);
    // breadcrumbs = breadcrumbs.map(({title, route_path})=>({ pathname: route_path, title: title }));

    // const breadcrumbs = (aside && aside.breadcrumbs.length > 0) ? aside.breadcrumbs : header.breadcrumbs;
    // console.log("breadcrumbs",breadcrumbs)
    // subheader.setBreadcrumbs(breadcrumbs.reverse());

    // subheader.setBreadcrumbs([
    //   { pathname: "/emy-projects", title: "emy-project" },
    //   { pathname: "/emy-projects/projects", title: "projects" },
    // ]);

    // subheader.setTitle((aside && aside.title && aside.title.length > 0) ? aside.title : header.title);
    //  subheader.setTitle(currentRoute.title);
     // eslint-disable-next-line
  }, [location.pathname]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {}, [subheader]);
  useEffect(()=>{
    setMenu(getMenu(role))
  }, [role,formatMessage])

  return (
      <>
        <div
            id="kt_subheader"
            className={`subheader py-3 py-lg-6 ${layoutProps.subheaderCssClasses}`}
        >
          <div
              className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
          >
            <div className="d-flex align-items-center flex-wrap mr-1">
              {/* begin::Mobile Toggle */}
              {layoutProps.subheaderMobileToggle && (
                <button
                  className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
                  id="kt_subheader_mobile_toggle"
                >
                  <span />
                </button>
              )}
              {/* end::Mobile Toggle */}

              {/* begin::Heading */}

              <div className="d-flex align-items-baseline">
                {
                  [roles.provider, roles.client, roles.super_admin].includes(role) ?
                    subheader.toolbarActions :
                    MENU.map((menu, index)=>{
                      const {svg, route_path} = menu;
                      const title = formatMessage({id:menu.title})
                      const active = location.pathname.includes(route_path);
                      // if(active) console.log(location, route_path)
                      return (
                        <AEOverlayTrigger
                          key={index}
                          placement={"bottom"}
                          overlay={<Tooltip id={`tooltip_toolbar_action_${index}`}>{title}</Tooltip>}>
                          <Link
                            to={route_path}
                            // className={`btn ${btnIcon? 'btn-icon':''} bg-light-${location.pathname === pathname ? variant:'white'} mr-1 bg-hover-light-${variant} btn-sm`}
                            className={`btn ${!active? 'btn-icon':''} bg-white text-primary btn-text-dark-50 font-weight-bold btn-hover-icon-primary text-hover-primary ml-2`}
                            // onClick={()=>onClickCallBack && onClickCallBack()}
                          >
                            <AESVG path={svg} variant={active ? 'primary':''} size={!active && "xl"}/>
                            {active && <span className='font-weight-bold'>{title}</span>}
                          </Link>
                        </AEOverlayTrigger>
                      )
                    })
                }
                {/*{subheader.toolbarActions}*/}
                {/*<h2 className="subheader-title text-dark font-weight-bold my-2 mr-3"> {subheader.title} </h2>*/}
                {/*<BreadCrumbs items={subheader.breadcrumbs} />*/}
              </div>
              {/* end::Heading */}
            </div>
            <div className="d-flex align-items-center">
              <LanguageSelectorDropdown subheader/>

              {
                authUser ?
                  <>
                    <AEOverlayTrigger
                      overlay={<Tooltip id="toggle-quick-panel">{formatMessage({id:'QUICK_PANEL'})}</Tooltip>}
                      placement={'bottom'}
                    >
                      <a
                        href="#"
                        className="btn btn-icon btn-clean btn-lg position-relative pulse pulse-primary"
                        id="kt_quick_panel_toggle"
                        data-placement="right"
                        data-container="body"
                        data-boundary="window"
                      >

                        <AESVG
                          path={'/Layout/Layout-4-blocks.svg'}
                          size={'lg'}
                          variant={notificationsStatistics.total > 0 ? 'primary' : 'light'}
                        />
                        <span className="label label-sm label-light-primary label-rounded font-weight-bolder position-absolute top-0 right-0 mt-1 mr-1">
                          {notificationsStatistics.total}
                        </span>
                        {
                          notificationsStatistics.total > 0 &&
                          <span className="pulse-ring"/>
                        }

                      </a>

                    </AEOverlayTrigger>
                    {
                      authUser
                        .roles
                        .filter(r=>![role, roles.super_admin].includes(r))
                        .map(r=>(
                          <AEButton
                            key={r}
                            variant={'link-primary'}
                            fontWeight={'bold'}
                            variantHover={'bg-light'}
                            className={'ml-2 text-nowrap'}
                            onClick={ev=>{ setEmyRole(r); }}
                          >
                            <span className={'pr-1 font-weight-normal'}>
                              {formatMessage({id:'QUICK_USER.CHANGE_SESSION'})}
                            </span>

                            {formatMessage({id:r})}
                            {/*<AESVG*/}
                            {/*  path={"/Navigation/Exchange.svg"}*/}
                            {/*  // size={"lg"}*/}
                            {/*  className={"ml-1"}*/}
                            {/*/>*/}
                          </AEButton>
                        ))
                    }

                    <QuickUserToggler />
                  </> :
                  <AEButton
                    // icon
                    variant={'link-primary'}
                    fontWeight={'bold'}
                    variantHover={'bg-light'}
                    className={'mr-3 text-nowrap'}
                    // className="btn-text-dark-50 btn-icon-primary font-weight-bold btn-hover-bg-light mr-3"
                    onClick={event => {
                      history.push('/logout')
                    }}
                  >
                    {/*<AESVG*/}
                    {/*  path={'/General/User.svg'}*/}
                    {/*  size={'lg'}*/}
                    {/*  variant={'primary'}*/}
                    {/*/>*/}
                    {formatMessage({id:'SIGN_IN'})}
                  </AEButton>
              }

              {/*{*/}
              {/*  role === roles.visitor &&*/}
              {/*    <>*/}


              {/*    </>*/}
              {/*}*/}
              {/*<AERole accept={[roles.visitor]} isEmailVerified={false}>*/}

              {/*</AERole>*/}


              {/*<SearchDropdown />*/}
            </div>


          </div>
        </div>

        {
          authUser && !isEmailVerified &&
          <div className={"container"}>
            <div className="alert alert-custom alert-white alert-shadow fade show " role="alert">
              <div className="alert-icon">
                <AESVG path={"/Code/Warning-2.svg"} variant={"primary"} size={"xl"}/>
              </div>
              <div className="alert-text">
                <span dangerouslySetInnerHTML={{__html: formatHTMLMessage({id:'SUBHEADER.EMAIL_ALERT.TEXT'},{link:formatMessage({id:'SUBHEADER.EMAIL_ALERT.LINK_TEXT'})})}} />
                {/*{formatHTMLMessage({id:'SUBHEADER.EMAIL_ALERT.TEXT'})}*/}
                <AEButton
                  fontWeight={"bold"}
                  variant={"light"}
                  size={"sm"}
                  onClick={e=>{
                    requestEmailVerificationLink().then(()=>{
                      toast("SENT !",{type:toast.TYPE.SUCCESS})
                    }).catch(r=>{
                      toast("ERROR !",{type:toast.TYPE.ERROR})
                    })
                  }}
                >
                  <span dangerouslySetInnerHTML={{__html: formatMessage({id:'SUBHEADER.EMAIL_ALERT.LINK_TEXT'})}} />
                </AEButton>
              </div>
            </div>
          </div>
        }
      </>

  );
}
